import { AdvertiserUser } from '../interfaces/entities/user'

export const advertiserUsers: AdvertiserUser[] = [
  {
    id: '1',
    advertiserId: '200',

    username: 'username@email.com',
    email: 'email@email.com',
    firstName: 'John',
    lastName: 'Doe',
    restrictedAccess: true,
  },
  {
    id: '2',
    advertiserId: '202',

    username: 'username1@email.com',
    email: 'email1@email.com',
    firstName: 'Jane',
    lastName: 'Doe',
    restrictedAccess: false,
  },
]
